import { ChangeEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomInput, Text } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { getTargets, updateTarget } from '../../../../../../redux/State/clientSlice/programTargetSlice';
import {
	CreateProgramTargetProperties,
	TargetProperties,
} from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

const TargetInstructions = ({ data, id, programId }: { data: TargetProperties; id: string; programId: string }) => {
	const { targetInstructions } = data;
	const dispatch = useDispatch<DispatchProperties>();
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const [instructions, setInstructions] = useState<string>('');

	useEffect(() => {
		if (!targetInstructions) return;

		setInstructions(targetInstructions);
	}, [targetInstructions]);

	const onTargetInstructionsChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setInstructions(value);
	};

	const updateTagetHandler = async () => {
		if (!programId || !id) return;

		const newData: CreateProgramTargetProperties = {
			...data,
			targetInstructions: instructions,
			typeId: data.type.id,
			masteryCriteria: data.masteryCriteria.id,
		};

		dispatch(updateTarget({ data: newData, programId, id }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				toast('Updated');
			})
			.catch(errorNormalizer);
	};

	return (
		<div
			style={{
				padding: '10px 0px',
			}}
		>
			<Text title="Target Instructions" type="h6" font="header" fontWeight="semiBold" className="marginBottom8" />
			<CustomInput value={instructions} onChange={onTargetInstructionsChange} multiline className="marginBottom16" />
			<CustomButton title="Save" onClick={updateTagetHandler} />
		</div>
	);
};

export default TargetInstructions;
